import breakpoints from 'scss-settings/_settings.grid.scss';

const html = document.documentElement;

class DetectBreakpoints {
    get breakpoint() {
        return this.addBreakpoint();
    }
    
    constructor() {
        html.classList.add(`u-breakpoint--${this.addBreakpoint()}`);
    }


    addBreakpoint() {
        const {innerWidth} = window;
        let visibleBreakpoint = 'xs';
        Object.keys(breakpoints).forEach(function(key) {
            if(breakpoints[key] <= innerWidth) visibleBreakpoint = key;
        });
        return visibleBreakpoint;
    }
}

export default new DetectBreakpoints();
